import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const prefetched = new Set();

// Warms the story JSON (lands in the service-worker API cache) and the
// StoryPage route chunk so tapping a card renders near-instantly.
export const prefetchStory = (slug) => {
  if (!slug || prefetched.has(slug)) return;
  prefetched.add(slug);
  axios.get(`${API}/stories/${slug}`).catch(() => prefetched.delete(slug));
  import('../pages/StoryPage').catch(() => {});
};

// iter359 · FLYT link + FLYT ID™ + Network profile prefetch. Called on
// hover/focus of any tile that links to /l/<slug>, /l/agent/<slug>, or
// /network/<slug>. Warms the API JSON (60s browser + CDN cached) AND
// the route chunk so the tap-to-paint feels instant. Idempotent — any
// (kind, slug) pair only fires once per app session.
export const prefetchFlytLink = (slug) => {
  const key = `flyt:${slug}`;
  if (!slug || prefetched.has(key)) return;
  prefetched.add(key);
  axios.get(`${API}/athletes/${slug}/share-page`).catch(() => prefetched.delete(key));
  import('../pages/AthleteSharePage').catch(() => {});
};

export const prefetchAgentLink = (slug) => {
  const key = `agent:${slug}`;
  if (!slug || prefetched.has(key)) return;
  prefetched.add(key);
  axios.get(`${API}/agent-link/${slug}`).catch(() => prefetched.delete(key));
  import('../pages/AgentLinkPublicPage').catch(() => {});
};

export const prefetchNetworkProfile = (slug) => {
  const key = `net:${slug}`;
  if (!slug || prefetched.has(key)) return;
  prefetched.add(key);
  // Prefetch BOTH endpoints the network profile page reads on mount.
  axios.get(`${API}/network/athletes/${slug}/profile`).catch(() => prefetched.delete(key));
  import('../pages/AthleteNetworkPage').catch(() => {});
};
